/*
 * @Description:抖音待编渠道路由
 * @Author: cc
 * @LastEditors: cc
 * @Date: 2019-10-26
 * @LastEditTime: 2021-01-05 11:20:50
 */
'use strict';
angular.module('editTrillToBeCompiledRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.editctr.trill.waitcompiled', {
                url: '/waitcompiled?account&isOriginal?channelid', // accountid->账号
                views: {
                    'main@front.editctr': {
                        templateUrl:
                            './editingCenter/trill/toBeCompiled/main.html',
                        controller: 'EditTrillToBeCompiledCtrl'
                    }
                }
            })
            .state('trillnews', {
                url:
                    '/trillnews?accountid&douyinarticleid&isOriginal&platform&isawaitrevise', // douyinarticleid->文章ID，加上douyin为了融合编辑器
                views: {
                    '': {
                        templateUrl:
                            './editingCenter/trill/news/trill_toBeCompiled_news.html',
                        controller: 'editingCenterTrillNewsCtrl'
                    }
                }
            });
    }
]);
